<nb-select *ngIf="labels()" fullWidth [(selected)]="value" [compareWith]="compareByFn" [disabled]="isDisabled" placeholder="Label auswählen">
  <nb-option [value]="undefined">Keine Auswahl</nb-option>
  <nb-option *ngFor="let label of labels()" [value]="label">
    <span>{{ label.name }} ({{label.dimension | dimensionTranslation}})</span>
  </nb-option>
</nb-select>
